export default function Hero() {
  return (
    <section className="relative bg-plum overflow-hidden pt-16 md:pt-20">
      <div className="relative flex flex-col lg:flex-row min-h-[360px] md:min-h-[500px] max-w-[1280px] mx-auto">
        {/* Texte gauche */}
        <div className="w-full lg:w-[55%] flex flex-col justify-center px-4 md:px-8 lg:px-12 py-8 md:py-12 lg:py-16 relative z-10">
          <p className="font-serif italic text-rose-200 text-sm md:text-base mb-4">
            DF PRO — Réparation de fenêtre
          </p>
          <h1 className="font-serif text-3xl md:text-4xl lg:text-5xl font-bold text-white leading-tight mb-4">
            Nos zones d&apos;intervention dans le Bas-Rhin
          </h1>
          <p className="text-rose-100 text-base md:text-lg leading-relaxed mb-8 max-w-xl">
            Nos techniciens se déplacent partout à Strasbourg et dans le Bas-Rhin. Devis gratuit, pièce comprise.
          </p>
          <div className="flex flex-col sm:flex-row gap-3">
            <a
              href="tel:0374471036"
              className="inline-flex items-center justify-center gap-2 bg-coral text-white px-6 py-4 rounded-xl font-semibold text-base whitespace-nowrap hover:bg-coral-light transition-colors"
            >
              <i className="ri-phone-line" />
              Appeler le 03 74 47 10 36
            </a>
            <a
              href="#devis"
              className="inline-flex items-center justify-center gap-2 border-2 border-white/30 text-white px-6 py-4 rounded-xl font-semibold text-base whitespace-nowrap hover:bg-white/10 transition-colors"
            >
              Devis gratuit
              <i className="ri-arrow-down-line" />
            </a>
          </div>
          <div className="flex flex-wrap gap-4 mt-8 text-rose-100 text-xs md:text-sm">
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-coral" />
              Intervention 24h
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-coral" />
              Devis gratuit
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-coral" />
              Toutes marques
            </span>
            <span className="flex items-center gap-1.5">
              <i className="ri-check-line text-coral" />
              Garantie 10 ans
            </span>
          </div>
        </div>

        {/* Image droite */}
        <div className="w-full lg:w-[45%] relative">
          <div className="absolute inset-0 lg:inset-y-8 lg:right-8 lg:left-0 rounded-none lg:rounded-2xl overflow-hidden">
            <img
              src="https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/3553f70ef7a1a743d1c0f13382581e92.jpeg"
              alt="Carte des zones d'intervention réparation fenêtre dans le Bas-Rhin"
              className="w-full h-full object-cover object-top"
              loading="eager"
            />
            <div className="absolute inset-0 bg-gradient-to-r from-plum/80 via-plum/20 to-transparent lg:from-plum/60" />
          </div>
        </div>
      </div>
    </section>
  );
}